<template>
  <div class="honor">
    <div class="header">
      <strong class="title">{{$t("companies.honorTitle")}}</strong>
      <div class="sub">{{$t("companies.honorSubtitle")}}</div>
    </div>
      <div class="swiper-box">
          <div class="left" style="transform: rotate(180deg);" @click="throttledMove('prev')">
            <svg t="1652693494132" class="icon" viewBox="0 0 1024 1024 " version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3309" width="24" height="24">
              <path d="M653.248 727.296L608 682.048l149.024-149.056H192v-64h564.992L608 320l45.248-45.248 226.272 226.24z" p-id="3310" fill="#bfbfc0"></path>
            </svg>
          </div>
          <div class="content" ref="carouseRef">
            <div v-for="(item, index) in carouselList" class="item" :key="index">
              <el-image
                  class="img"
                  @click="handlerPrev(item.imgUrl)"
                  :src="item.imgUrl"
                  :preview-src-list="srcList">
              </el-image>
              <div class="name" @click.prevent.stop="handlerItem(item)">{{item.title}}</div>
            </div>
          </div>
          <div class="right" @click="throttledMove('next')">
            <svg t="1652693494132" class="icon" viewBox="0 0 1024 1024 " version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3309" width="24" height="24">
              <path d="M653.248 727.296L608 682.048l149.024-149.056H192v-64h564.992L608 320l45.248-45.248 226.272 226.24z" p-id="3310" fill="#bfbfc0"></path>
            </svg>
          </div>
      </div>
    </div>
</template>
<script>
export default {
  computed: {
    carouselList()
    {
      return [
        // 前面补充占位开始
        {
          imgUrl: require('@/assets/img/other/1746605039_Yahv.jpg'),
          title: this.$t("companies.honorCarouse11")
        },
        {
          imgUrl: require('@/assets/img/other/1746605055_fEQK.jpg'),
          title: this.$t("companies.honorCarouse11")
        },
        {
          imgUrl: require('@/assets/img/other/1746605070_nrfB.png'),
          title: this.$t("companies.honorCarouse12")
        },
        // 前面补充占位结束
        {
          imgUrl: require('@/assets/img/other/1746604871_OLiU.png'),
          title: this.$t("companies.honorCarouse1")
        },
        {
          imgUrl: require('@/assets/img/other/1746604883_kVv6.jpg'),
          title: this.$t("companies.honorCarouse2")
        },
        {
          imgUrl: require('@/assets/img/other/1746604906_Mc9d.jpg'),
          title: this.$t("companies.honorCarouse2")
        },
        {
          imgUrl: require('@/assets/img/other/1746604922_u5ht.png'),
          title: this.$t("companies.honorCarouse3")
        },
        {
          imgUrl: require('@/assets/img/other/1746604937_kwwA.jpg'),
          title: this.$t("companies.honorCarouse4")
        },
        {
          imgUrl: require('@/assets/img/other/1746604952_CZWL.png'),
          title: this.$t("companies.honorCarouse5")
        },
        {
          imgUrl: require('@/assets/img/other/1746604967_craK.jpg'),
          title: this.$t("companies.honorCarouse6")
        },
        {
          imgUrl: require('@/assets/img/other/1746604983_rngK.jpg'),
          title: this.$t("companies.honorCarouse7")
        },
        {
          imgUrl: require('@/assets/img/other/1746605000_bKPt.jpg'),
          title: this.$t("companies.honorCarouse8")
        },
        {
          imgUrl: require('@/assets/img/other/1746605023_J1Ya.png'),
          title: this.$t("companies.honorCarouse9")
        },
        {
          imgUrl: require('@/assets/img/other/1746605039_Yahv.jpg'),
          title: this.$t("companies.honorCarouse11")
        },
        {
          imgUrl: require('@/assets/img/other/1746605055_fEQK.jpg'),
          title: this.$t("companies.honorCarouse11")
        },
        {
          imgUrl: require('@/assets/img/other/1746605070_nrfB.png'),
          title: this.$t("companies.honorCarouse12")
        },
        // 后面补充占位开始
        {
          imgUrl: require('@/assets/img/other/1746604871_OLiU.png'),
          title: this.$t("companies.honorCarouse1")
        },
        {
          imgUrl: require('@/assets/img/other/1746604883_kVv6.jpg'),
          title: this.$t("companies.honorCarouse2")
        },
        {
          imgUrl: require('@/assets/img/other/1746604906_Mc9d.jpg'),
          title: this.$t("companies.honorCarouse2")
        }
        // 后面补充占位结束
      ]
    },
  },
  data() {
    return {
      srcList: [],
      currentIndex: 2,
      lastClickTime: 0,
      throttleDelay: 300
    }
  },
  mounted () {
    const element = this.$refs.carouseRef;
    if (element) {
      element.style.transform = `translateX(${-26 * (this.currentIndex + 1)}vw)`;
      element.style.transition = 'transform 0.5s ease';
    }
  },
  methods: {
    handlerPrev(src)
    {
      this.srcList = [src];
    },
    // 节流函数
    throttledMove(type) {
      const now = Date.now();
      // 判断是否超过节流时间
      if (now - this.lastClickTime >= this.throttleDelay) {
        this.scrollElement(type);
        this.lastClickTime = now;
      }
    },
    scrollElement(type)
    {
      if(type === "next")
      {
        this.currentIndex++;
      }
      else
      {
        this.currentIndex--;
      }
      const element = this.$refs.carouseRef;
      if (element) {
        element.style.transform = `translateX(${-26 * (this.currentIndex + 1)}vw)`;
        element.style.transition = 'transform 0.3s ease';
      }
      // 判断右边是否到头
      if(this.currentIndex === this.carouselList.length - 4)
      {
        setTimeout(()=>{
          this.currentIndex = 2;
          element.style.transform = `translateX(${-26 * (this.currentIndex + 1)}vw)`;
          element.style.transition = 'transform 0s';
        },this.throttleDelay)
      }
      // 判断左边是否到头
      if(this.currentIndex === -1)
      {
        setTimeout(()=>{
          this.currentIndex = this.carouselList.length - 7;
          element.style.transform = `translateX(${-26 * (this.currentIndex + 1)}vw)`;
          element.style.transition = 'transform 0s';
        },this.throttleDelay)
      }
    },
    handlerItem()
    {
      // this.$router.push({
      //   path: '/photo'
      // })
    }
  }
}
</script>
<style lang="scss" scoped>
  .honor{
      font-family: $font-family;
    .header{
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 30px 0;
      .title{
        font-size: $title-font-size;
        color:#000000;
        @media screen and (max-width: 768px) {
          font-size: $phone-title-font-size;
        }
      }
      .sub{
        margin-top: 2px;
        font-size: $subtitle-font-size;
        color:#fccc0c;
        @media screen and (max-width: 768px) {
          font-size: $phone-subtitle-font-size;
           margin-top: 0.2rem;
        }
      }
    }
  }
  .swiper-box{
    width: 78vw;
    height: 400px;
    margin: 30px auto;
    position: relative;
    overflow: hidden;
    .left{
      width: 30px;
      height: 30px;
      position: absolute;
      left: 1rem;
      top: 50%;
      cursor: pointer;
      z-index: 99;
      border: 1px solid #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      transform: translateY(-50%);
    }
    .right{
      width: 30px;
      height: 30px;
      position: absolute;
      right: 1rem;
      top: 50%;
      cursor: pointer;
      z-index: 99;
      border: 1px solid #ccc;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      transform: translateY(-50%);
    }
    .content{
      height: 400px;
      width: 99999vw;
      overflow: hidden;
      display: flex;
      justify-content: flex-start;
      text-align: center;
      .item{
        width: 26vw !important;
        height: 380px;
        background-color: #fff;
          font-size: 1rem;
        @media screen and (max-width: 768px) {
          height: 10rem;
          width: 33.33%;
        }
        &:hover{
          box-shadow: 0 0 10px #ccc;
          transform: translateY(-4px);
          transition: all 0.5s;
          .name{
            color: #794bb7;
          }
        }
        .img{
          height: 250px;
          margin-top: 25px;
          margin-bottom: 25px;
          @media screen and (max-width: 768px) {
            height:5rem;
            width: 100%;
          }
        }
      }
    }
  }
</style>
